<template>
  <Wrapper class="mwe-overlay-layout" :custom_style="{ width }">
    <b-sidebar
      :visible="active"
      title="Sidebar"
      no-header
      bg-variant="white"
      :no-close-on-esc="true"
      :no-close-on-route-change="true"
      no-enforce-focus
    >
      <div class="h-100 d-flex flex-column">
        <OverlayHeader class="overlay-header d-flex flex-column px-gd-3 py-gd-2">
          <DetailName>
            <div class="row -mx-gd-1">

              <div class="col-auto pl-gd-1 pr-gd-0" v-if="backbtn">
                <span class="text-dark cursor-pointer opacity-hover-50" @click="close()">
                  <i class="fal fa-arrow-left fs-16"></i>
                </span>
              </div>

              <div class="col px-gd-1 text-truncate">
                <TitleSidebar :label="titleDisplay" /> {{lblExample}} 
              </div>

              <div class="col-auto px-gd-1" v-if="closebtn">
                <span 
                  class="text-dark cursor-pointer opacity-hover-50"
                  @click="
                    elActive({ elementID: undefined });
                    $store.dispatch('design/setMode', {});
                  "
                >
                  <i class="fal fa-times fs-20"></i>
                </span>
              </div>
              
            </div>
          </DetailName>
          <Navigate v-if="navigate" />
        </OverlayHeader>
        <OverlayBody class="overlay-body flex-grow-1">
          <slot name="body"></slot>
        </OverlayBody>
      </div>
    </b-sidebar>
  </Wrapper>
</template>

<script>
import {
  OverlayHeader,
  OverlayBody,
  DetailName,
  Wrapper,
} from "./OverlayLayout.styled";
import { capitalize } from "@helpers/text.helper";
import TitleSidebar from "@components_system/Shared/Elements/Texts/TitleSidebar";
import Navigate from "@components_system/Design/Sidebar/Overlay/Navigate";
import { mapGetters } from "vuex";

export default {
  components: {
    OverlayHeader,
    OverlayBody,
    DetailName,
    TitleSidebar,
    Navigate,
    Wrapper,
  },
  methods: {
    elActive({ elementID, lv = 0 }) {
      this.$store.dispatch("design/component/elActive", { elementID, lv });
      this.$store.dispatch("designIframe/frame/setSectionActive", {});
      this.$store.dispatch("designIframe/frame/setWidgetActive", {});
      this.$store.dispatch("designIframe/frame/setSlideBlockActive", {});
      this.$store.dispatch("designIframe/frame/setSectionHover", {});
      this.$store.dispatch("designIframe/frame/setWidgetHover", {});
      this.$store.dispatch("designIframe/frame/setSlideBlockHover", {});
      this.$store.dispatch("designIframe/frame/setFloatFrameHover", {});
      this.$store.dispatch("designIframe/frame/setFloatFrameActive", {});
      this.$store.dispatch("designIframe/frame/setSlideSectionHover", {});
      this.$store.dispatch("designIframe/frame/setSlideSectionActive", {});
      this.$store.dispatch("designIframe/frame/setSlideContainerHover", {});
      this.$store.dispatch("designIframe/frame/setSlideContainerActive", {});
    },
    lblSidebarTitle(sidebarTitle){
      //? $te = check exists key
      if(this.$te(`engine.sidebarTitle.component.${sidebarTitle.toUpperCase()}`, this.languageEngine)){
        return this.$t(`engine.sidebarTitle.component.${sidebarTitle.toUpperCase()}`, this.languageEngine);
      }else{
        return capitalize(sidebarTitle);
      }
    }
  },
  computed: {
    ...mapGetters({
      components: "design/metadata/components",
      languageEngine: "design/userPreference/languageEngine",
      elActiveID: "design/component/elActiveID",
      screenSize: "screenSize",
      isExamplePage: "design/page/isExamplePage",
    }),
    titleDisplay() {
      if (this.screenSize == 'Desktop') {
        if (this.components[this.title]) {
          let componentType = this.components[this.title].type;
          if (componentType.startsWith("SECTION_WIDGET") || componentType.startsWith("SECTION_PAGE") || componentType.startsWith("SLIDE_SECTION") || componentType.startsWith("SLIDE_CONTAINER") || componentType.startsWith("SECTION_CELL")) {
            return this.$t(
              "engine.sidebarTitle.component." + componentType,
              this.languageEngine
            );
          } else {
            let sidebarTitle = capitalize(this.components[this.title].type.split("_").slice(-1)[0]);
            switch (sidebarTitle) {
              case 'Section':
                return this.$t('engine.sidebarTitle.component.SECTION', this.languageEngine);
            
              default:
                return sidebarTitle;
            }
          }
        } else if (
          (this.elActiveID[0] == 'header' || this.elActiveID[0] == 'footer') && 
          (this.elActiveID[2] == undefined || this.elActiveID[2] == 'text' || this.elActiveID[2] == 'text1' || this.elActiveID[2] == 'text2' || this.elActiveID[2] == 'text3' || this.elActiveID[2] == 'text4' || this.elActiveID[2] == 'copyright' || this.elActiveID[2] == 'fblikebox')) {
          /* return capitalize(this.elActiveID[0]) */
          return this.$t(`engine.sidebarTitle.component.${this.elActiveID[0].toUpperCase()}`,this.languageEngine)
        } 
        else {
          return this.lblSidebarTitle(this.title);
        }
      } else {
        return this.title;
      }
    },
    lblExample() {
      return this.isExamplePage ? `(${this.$t('engine.topbar.page.lblTitleExamplePage', this.languageEngine)})` : ''
    }
  },

  props: {
    closebtn: {
      type: Boolean,
      default: true,
    },
    backbtn: {
      type: Boolean,
      default: true,
    },
    width: {
      type: Number,
    },
    navigate: {
      type: Boolean,
      default: true,
    },
    active: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    close: {
      type: Function,
      default: () => {},
    },
  },
};
</script>

<style></style>
